import { DefineComponentProps } from 'utils'
import './CommonCell.scss'

type CommonCellProps = {
  title: string
}

export const CommonCell = defineComponent<CommonCellProps>({
  props: DefineComponentProps<CommonCellProps>(['title']),
  setup(props, { slots }) {
    return () => (
      <div class="common-cell flex justify-between items-center">
        <span class="text-[13px] text-[var(--colors-text-secondary)]">{props.title}</span>
        <div class="flex items-center gap-x-[4px] font-[500]">
          <span>{slots.default?.()}</span>
        </div>
      </div>
    )
  },
})
